import { render } from "./DebriyajDiski.vue?vue&type=template&id=85e6e4ca"
import script from "./DebriyajDiski.vue?vue&type=script&lang=js"
export * from "./DebriyajDiski.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__